var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.075 0.125714C17.8689 0.22709 17.6759 0.353003 17.5 0.500714L6.775 11.2007C6.08464 11.8911 6.08464 13.0104 6.775 13.7007C7.46536 14.3911 8.58464 14.3911 9.275 13.7007L17 5.97571V26.4257C17 27.3922 17.7835 28.1757 18.75 28.1757C19.7165 28.1757 20.5 27.3922 20.5 26.4257V5.97571L28.2 13.7257C28.8904 14.4161 30.0096 14.4161 30.7 13.7257C31.3904 13.0354 31.3904 11.9161 30.7 11.2257L20 0.500714C19.8241 0.353003 19.6311 0.22709 19.425 0.125714C18.9906 -0.0419048 18.5094 -0.0419048 18.075 0.125714ZM37.5 31.25V24.775C37.5 23.8085 36.7165 23.025 35.75 23.025C34.7835 23.025 34 23.8085 34 24.775V31.25C33.9483 32.7469 32.7469 33.9483 31.25 34H6.25C4.75314 33.9483 3.55166 32.7469 3.5 31.25V24.775C3.5 23.8085 2.7165 23.025 1.75 23.025C0.783502 23.025 0 23.8085 0 24.775V31.25C0.0535931 34.6793 2.82066 37.4464 6.25 37.5H31.25C34.6793 37.4464 37.4464 34.6793 37.5 31.25Z",
    fill: "#5D7B96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.99953d2db0eef1d4e2dc6a4f37c62dc5.svg";
export { ForwardRef as ReactComponent };